import type { AnalyticsSurface } from '@/shared/surfaces/AnalyticsSurface';
import ClassificationSurfaceCard from '@/features/classification/ClassificationSurfaceCard';
import { ADOPTION_CATALOG } from '@/features/behavior/BehaviorAdoptionCatalog';

/** The Adoption surface: the composite adoption-score screen is the section Overview; the catalog carries the heatmap and momentum drill-ins with side-rail framing. */
export const ADOPTION_SURFACE: AnalyticsSurface = {
    id: 'adoption',
    basePath: '/adoption',
    title: 'Adoption',
    subtitle: 'Who has embraced AI and where the momentum is — the team heatmap and the active-user trend over time.',
    catalog: ADOPTION_CATALOG,
    gallery: { lead: 'none', cardStyle: 'standard', columns: { base: 1, md: 2, xl: 3 }, signals: true },
    assist: true,
    drillStyle: 'side-rail',
    trailingCard: <ClassificationSurfaceCard category="Adoption" variant="standard" />,
};
